import React, { useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import MultiAttachmentComponent from './MultiAttachmentComponent';
import {
  DEFAULT_FILE_UPLOAD_SIZE_LIMIT_IN_MB,
  MAX_FILE_LIMIT_IN_MULTI_FILE_UPLOAD_ELEMENT,
} from '../../../HelperMethods/constants';
import { formikPropType } from '../../../common/prop-types';

export default function FormikEnabledMultiAttachment({ attributeObj, formik, isCommonFieldDisabled, print }) {
  const err = _.get(formik, `errors.${attributeObj.id}`);
  const { allowedFormat, label: fieldName, disabled, id: attributeObjId } = attributeObj;
  const fileSizeLimitInMB = attributeObj.sizeLimit || DEFAULT_FILE_UPLOAD_SIZE_LIMIT_IN_MB;
  const maxLimitNumberOfFiles = MAX_FILE_LIMIT_IN_MULTI_FILE_UPLOAD_ELEMENT;
  const uploadedFileObjArr = _.get(formik.values, attributeObjId) || [];
  const onChange = useCallback(
    (uploadFileObjects) => {
      const fileObjArr = _.get(formik.values, attributeObjId) || [];
      fileObjArr.push(...uploadFileObjects);
      formik.setFieldValue(attributeObjId, fileObjArr, false);
    },
    [attributeObjId, formik]
  );

  const onCancelAnAttachment = useCallback(
    (key) => {
      const fileObjArr = (_.get(formik.values, attributeObjId) || []).filter((obj) => obj.key !== key);
      formik.setFieldValue(attributeObjId, fileObjArr, false);
    },
    [attributeObjId, formik]
  );

  return (
    <MultiAttachmentComponent
      allowedFormats={allowedFormat}
      disabled={isCommonFieldDisabled || disabled}
      fileSizeLimitInMB={fileSizeLimitInMB}
      onChange={onChange}
      errorMessage={err}
      fieldName={fieldName}
      uploadedFiles={uploadedFileObjArr}
      isRequired={attributeObj?.isRequired}
      onCancelAnAttachment={onCancelAnAttachment}
      maxLimitNumberOfFiles={maxLimitNumberOfFiles}
      print={print}
      isRequiredOnCreation={attributeObj?.isRequiredOnCreation}
      isCreate={!attributeObj?.taskId}
    />
  );
}
FormikEnabledMultiAttachment.propTypes = {
  attributeObj: PropTypes.object.isRequired,
  formik: formikPropType.isRequired,
  isCommonFieldDisabled: PropTypes.bool.isRequired,
  print: PropTypes.bool.isRequired,
};
